import { appConfig } from '@/config/app.ts'
import { MonthlyCut } from '@/modules/allies/monthlyCut/types/MonthlyCut.ts'

export interface MonthlyCutState {
  isLoading: boolean
  filters: string
  selectedAllyId: string
  selectedRows: MonthlyCut[]
}

export const initialState: MonthlyCutState = {
  isLoading: false,
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  selectedAllyId: '',
  selectedRows: []
}
